export default "__VITE_ASSET__Ch9wmVmm__"